window.jQuery = $;
window.$ = $;
// const bootstrap = require('bootstrap');
const datepicker = require('bootstrap-datepicker');
function getOrCreateTooltip(el) {
    let tooltip = bootstrap.Tooltip.getInstance(el);
    if (!tooltip) {
        tooltip = new bootstrap.Tooltip(el, {
            html: true,
            trigger: 'manual',
            customClass: 'agencea-cures-tooltip-popover',
            title: el.getAttribute('data-bs-title') || 'Chargement...'
        });
    }
    return tooltip;
}

function getTooltipElementFromEventTarget(target) {
    if (!target) return null;
    const elementTarget = target.nodeType === 1 ? target : target.parentElement;
    if (!elementTarget || typeof elementTarget.closest !== 'function') return null;
    return elementTarget.closest('.agencea-cures-tooltip');
}

function isMobilePointer() {
    return window.matchMedia('(hover: none), (pointer: coarse)').matches;
}

function loadTooltipContent(el) {
    if (el.dataset.loaded === 'true' || el.dataset.loading === 'true') return;
    el.dataset.loading = 'true';

    $.ajax({
        url: agencea.ajaxurl,
        type: 'POST',
        data: {
            action: 'ajax_get_booking_next_step',
            type: el.dataset.type,
            value: el.dataset.value,
            parent: el.dataset.parent,
            level: el.dataset.level,
        },
        success: function (response) {
            const instance = bootstrap.Tooltip.getInstance(el);
            if (!instance) return;

            const html = response?.col3?.html || '';
            if (!html) return;

            const shouldBeVisible = el.matches(':hover');
            el.setAttribute('data-bs-original-title', html);
            el.setAttribute('data-bs-title', html);
            instance.dispose();
            const refreshedTooltip = getOrCreateTooltip(el);
            if (shouldBeVisible) {
                refreshedTooltip.show();
            }
            el.dataset.loaded = 'true';
        },
        complete: function () {
            el.dataset.loading = 'false';
        }
    });
}

document.addEventListener('mouseover', function (e) {
    const el = getTooltipElementFromEventTarget(e.target);
    if (!el) return;
    if (el.contains(e.relatedTarget)) return;

    const tooltip = getOrCreateTooltip(el);
    tooltip.show(); // Affiche immédiatement "Chargement..." au premier survol
    loadTooltipContent(el);
});

document.addEventListener('mouseout', function (e) {
    const el = getTooltipElementFromEventTarget(e.target);
    if (!el) return;
    if (el.contains(e.relatedTarget)) return;

    const tooltip = bootstrap.Tooltip.getInstance(el);
    if (tooltip) {
        tooltip.hide();
    }
});

document.addEventListener('click', function (e) {
    const el = getTooltipElementFromEventTarget(e.target);
    if (!el || !isMobilePointer()) return;

    e.preventDefault();
    e.stopPropagation();

    const tooltip = getOrCreateTooltip(el);
    if (el.classList.contains('tooltip-opened')) {
        tooltip.hide();
        el.classList.remove('tooltip-opened');
        return;
    }

    tooltip.show();
    loadTooltipContent(el);
    el.classList.add('tooltip-opened');
});
;(function($){
	$.fn.datepicker.dates['fr'] = {
		days: ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"],
		daysShort: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
		daysMin: ["D", "L", "Ma", "Me", "J", "V", "S"],
		months: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "novembre", "décembre"],
		monthsShort: ["Janv.", "Févr.", "Mars", "Avril", "Mai", "Juin", "Juil.", "Août", "Sept.", "Oct.", "Nov.", "Déc."],
		today: "Aujourd'hui",
		monthsTitle: "Mois",
		clear: "Effacer",
		weekStart: 1,
		format: "dd/mm/yyyy"
	};
}(jQuery));

$(function () {


    var currentFocus = -1;
    var fetchTrigger = 0;

    // Fonction pour mettre en forme visuellement un résultat sélectionné
    function setActive() {
        var nbVal = $("div.address-feedback a").length;
        if (!nbVal)
            return false; // Si on n'a aucun résultat listé, on s'arrête là.
        // On commence par nettoyer une éventuelle sélection précédente
        $('div.address-feedback a').removeClass("active");

        // Bidouille mathématique pour contraindre le focus dans la plage du nombre de résultats
        currentFocus = ((currentFocus + nbVal - 1) % nbVal) + 1;

        $('div.address-feedback a:nth-child(' + currentFocus + ')').addClass("active");
    }

    // Au clic sur une adresse suggérée, on ventile l'adresse dans les champs appropriés. On espionne click plutôt que click pour l'attraper avant la perte de focus du champ adresse.
     $(document).on("click", '.address-feedback a', function(event) {
        // Stop la propagation par défaut
        event.preventDefault();
        event.stopPropagation();
        $("#address").val($(this).attr("data-name"));
        $("#zipcode").val($(this).attr("data-postcode"));
        $("#city").val($(this).attr("data-city"));

        $('.address-feedback').empty();
      

    });

    // On espionne le clavier dans le champ adresse pour déclencher les actions qui vont bien
    $(document).on('keyup', "#address", function(event) {

        // Stop la propagation par défaut
        event.preventDefault();
        event.stopPropagation();

        if (event.code === 'ArrowUp') { // Flèche HAUT
            currentFocus--;
            setActive();
            return false;
        } else if (event.code === 'ArrowDown') { // Flèche BAS
            currentFocus++;
            setActive();
            return false;
        } else if (event.code === 'Enter') { // Touche ENTREE
            if (currentFocus > 0) {
            // On simule un clic sur l'élément actif
            $("div.address-feedback a:nth-child(" + currentFocus + ")").trigger('click');
            }
            return false;
        }

        // Si on arrive ici c'est que l'user a avancé dans la saisie : on réinitialise le curseur de sélection.
        $('div.address-feedback a').removeClass("active");
        currentFocus = 0;

        // On annule une éventuelle précédente requête en attente
        clearTimeout(fetchTrigger);

        // Si le champ adresse est vide, on nettoie la liste des suggestions et on ne lance pas de requête.
        let rue = $("#address").val();
        if (rue.length === 0) {
            $('.address-feedback').empty();
            return false;
        }

        // On lance une minuterie pour une requête vers l'API.
        fetchTrigger = setTimeout(function() {

            // On lance la requête sur l'API
            $.get('https://api-adresse.data.gouv.fr/search/', {
                    q: rue,
                    limit: 15,
                    autocomplete: 1
                }, function(data, status, xhr) {
                let liste = "";
                $.each(data.features, function(i, obj) {
                    // données phase 1 (obj.properties.label) & phase 2 : name, postcode, city
                    // J'ajoute chaque élément dans une liste
                    let cooladdress = '<span class="fw-normal">' + obj.properties.name + " " + obj.properties.postcode + "</span> <strong>" + obj.properties.city + "</strong>";
                    liste += '<a class="list-group-item text-dark list-group-item-action py-1" href="/reservation" name="' + obj.properties.label + '" data-name="' + obj.properties.name + '" data-postcode="' + obj.properties.postcode + '" data-city="' + obj.properties.city + '">' + cooladdress + '</a>';
                });
                $('.address-feedback').html(liste);
            }, 'json');
        }, 500);
    });

    // On cache la liste si le champ adresse perd le focus
    $("#address").on('focusout', function() {
        $('.address-feedback').empty();
    });

    // On annule le comportement par défaut des touches entrée et flèches si une liste de suggestion d'adresses est affichée
    $(document).on('keydown', "#address", function(e) {
      
        if ($("div.address-feedback a").length > 0 && (e.code === 'ArrowUp' || e.code === 'ArrowDown' || e.code === 'Enter')) {
            e.preventDefault();
        }
    });

    // end autocomplete

    var current_step = 1 ;

    // Objet pour storer les valeurs choisies
    var current_user = 0;
  
    // var user_choices = {
    //     'term': [],
    //     'cure': [],
    //     'startDate': [],
    //     'options': [],
    //     'options_packs': [],
    //     'options_selection': [],
    //     'hosting': [],
    //     'hosting_selection': [],
    //     'hosting_options': [],
    //     'accompagnant': [],
    //     'accompagnant_cure': [],
    //     'info':[],
    //     'summary':[]
    // };

    var users = [
        {
            'term': [],
            'cure': [],
            'startDate': [],
            'options': [],
            'options_packs': [],
            'options_selection': [],
            'hosting': [],
            'hosting_selection': [],
            'hosting_options': [],
            'accompagnant': [],
            'accompagnant_cure': [],
            'info':[],
            'summary':[]
        },
        {
            'term': [],
            'cure': [],
            'startDate': [],
            'options': [],
            'options_packs': [],
            'options_selection': [],
            'hosting': [],
            'hosting_selection': [],
            'hosting_options': [],
            'accompagnant': [],
            'accompagnant_cure': [],
            'info':[],
            'summary':[]
        }
    ];



    function saveChoices(user_index, object, name, value){
        user_index = null !== user_index ? user_index : 0 ;

        // console.log(user_index) ;
        let _obj = {
            id: value,
            name: name
        };
        if(object === 'term'){
            users[user_index][object].push(_obj);
        }
        else if(object === 'info'){
            users[user_index][object] = value ;
        }
        else if(object === 'options_selection' || object === 'hosting_options'){
           // users[user_index][object] = value.split(',') ;
          // console.log(value);
           //console.log(name);
            var values = value.toString().split(',') ;
            var names = name.split(',') ;
            
            for (let index = 0; index < values.length; index++) {
                users[user_index][object].push({'id':values[index], 'name':names[index]})
            }
           
        }
        // else if(object === 'hosting_selection'){
        //     var values = value.split(',') ;
        //     var names = name.split(',') ;
            
        //     for (let index = 0; index < values.length; index++) {
        //         users[user_index][object].push({'id':values[index], 'name':names[index]})
        //     }
           
        // }
        else{
            users[user_index][object] = _obj;
        }

        //users[user_index] = user_choices ;

       // console.log(users);
      
        localStorage.setItem('users', JSON.stringify(users));
        if(object !== 'info'){
            choicesSummary(user_index, object, name, value);
        }
       
    }

    function choicesSummary(current_user, object, name, value){
        let target = $('[data-choice="'+object+'"][data-user="'+current_user+'"]') ;
        _name = name || value ;
        target.empty() ;
        if(current_user == 1){
            target.prev('.accompagnant-heading').removeClass('d-none');
        }

        if(value == 0){
            $('[data-dependancy="'+object+'"]').empty();
        }
        // if(object === 'options_selection'){
        //     name = '';
        //     for (let index = 0; index < values.length; index++) {
        //         name += users[current_user]values[index];
                
        //     }
        // }
        // console.log(object);
        // console.log(name);
        // console.log(value);
        
       // console.log(_name);
        target.append(_name.toString().split(',').join(', '));
        target.attr('data-value', value);
    }

    var loader = $('#bookingLoader');
  
    function hideLoader(){
        loader.addClass('d-none');
    }
    function showLoader(){
        loader.removeClass('d-none');
    }

    function toggleActiveStep(step, current_user){
        $('#booking').attr('data-step', step);
        $('#booking').attr('data-current_user', current_user);
        let accompagnant_text = (step != 'summary' && current_user == 1) ? '<small class="d-block accompagnant-subtitle">Accompagnant</small>' : '';
;        // col1
        $('#col1').find('.list-group-item').removeClass('active');
        $('#step'+step+'--title').addClass('active');
        $('#step'+step+'--title').find('.step-navigation').removeClass('disabled');

        // col2
        $('#current-step--title').html(accompagnant_text + step + '. ' + $('#step'+step+'--title').find('span:first').text());

       
        $('.step--content').removeClass('show');
        $('#step'+step+'--content').addClass('show');
    }

    function toggleActiveLevel(step, level){
        $('#step'+step+'--content').find('.type-level').each(function(){
            if(parseInt($(this).data('level')) >= parseInt(level)){
                // console.log(level); 
                // console.log($(this).data('level'));
                $(this).remove();
            }
        });
    }

    function calcWorkingDays(fromDate, days) {
        var count = 0;
        while (count < days) {
            fromDate.setDate(fromDate.getDate() + 1);
            if (fromDate.getDay() != 0 && fromDate.getDay() != 6) // Skip weekends
                count++;
        }
        return fromDate;
    }

    function estimateEndDate(date, cure_id){
        // @todo récupérer la durée réelle de la cure
        return calcWorkingDays(date, 18);
    }


    function ValidateEmail(value) {
        if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
            return true
        }
        return false
    }

    function get_name(sel){
        // var type = sel.prop('nodeName') ;
        // var name = 'undefined';
        var name = '';
        if( sel.is("input")) {
            name = sel.next('label').text();
        }
        if(name == '' && sel.data('name')){
            name = sel.data('name');
        }
        // else if(){
            
        // }
        return name ;
    }

    var getDaysArray = function(s,e) {for(var a=[],d=new Date(s);d<=new Date(e);d.setDate(d.getDate()+1)){ a.push(new Date(d).toLocaleDateString("fr"));}return a;};

    var datesDisabled = getDaysArray(new Date("2022-12-11"),new Date("2023-02-17"));
    var datesDisabled2 = getDaysArray(new Date("2024-12-15"),new Date("2025-02-23"));
    datesDisabled = datesDisabled.concat(datesDisabled2);
    var nextYear = new Date().getFullYear() + 1;

    $('body').on('focus',".birthday-datepicker", function(){
        let _date = new Date() ;
        $(this).datepicker({
            language: 'fr',
            defaultViewDate: `01/01/${Number(_date.getFullYear()) - 50}`,
            endDate: `31/12/${Number(_date.getFullYear()) - 18}`,
            startDate:`01/01/${Number(_date.getFullYear()) - 120}`
        });
    });


    $('body').on('focus',".booking-datepicker", function(){

        let daysOfWeekHighlighted = $(this).attr('id') === 'startDate' ? '0' : [] ;
        let daysOfWeekDisabled = $(this).attr('id') === 'startDate' ? [0] : [] ;
        if($(this).attr('id') === 'startDate' && users[current_user].cure.id == 558){
            daysOfWeekDisabled = [0,5,6];
        }
      
        let endDate = $(this).attr('id') === 'hostingDate' ? users[current_user].startDate.id : new Date(nextYear, 11, 10) ;
        $(this).datepicker({
            language: 'fr',
            startDate: '+2d',
            daysOfWeekHighlighted: daysOfWeekHighlighted,
            daysOfWeekDisabled: daysOfWeekDisabled,
            endDate: endDate,
            datesDisabled: datesDisabled
        });
        $(this).datepicker()
        .on('changeDate', function(e) {
            let button = $(this).parents('div').find('button') ;
           
            button.prop('disabled', false);
            button.attr('data-value', [e.date.getDate() ,e.date.getMonth() + 1,e.date.getFullYear() ].join('/'));
            //button.attr('data-name', 'Votre cure commence le '+ [e.date.getDate() ,e.date.getMonth() + 1,e.date.getFullYear() ].join('/'));

            /**
             * @deprecated
             */
            // let endDate = estimateEndDate(e.date, 10) ; // fake cure_id
            // let endDateFormatted = [endDate.getDate() ,endDate.getMonth() + 1,endDate.getFullYear() ].join('/') ;
            // $('#endDate').removeClass('invisible').find('span').text(endDateFormatted); 
        });
    });


    
    
    if($('#booking').length > 0){
        console.log('Init Booking form');
        var data = {
            'action': 'ajax_get_booking_next_step',
            'type' : 'term',
            'value' : 0,
            'parent' : 0,
            'level' : 1,
        };
        $.post(agencea.ajaxurl, data, function(response) {
            hideLoader();
            if(response.level){
                toggleActiveLevel(1, response.level);
            }
            $('#step'+response.step+'--content').html(response.col2.html);
            
            // $('#col3').html(response.col3.html);
            
        });

        // Click Step
        $(document).on('click', '.submit-choice', function() {

            showLoader();
            let valid = true ;
            var type = $(this).data('type');
            var value = $(this).attr('data-value');
            var parent = $(this).data('parent');
            var level = $(this).data('level');

            // console.log('value: '+  value);
            // console.log('value: '+  $(this).data('value'));

            let $this = $(this);

            var name = get_name($this);

            if(type === 'summary' || type === 'accompagnant_start'){
                let formData = {};
                $('form#info').find("input,textarea").each(function() {
                    let val = '' ;
                    if( $(this).is(':checkbox') ){
                        if($(this).prop('checked')){
                            val = $(this).val() ;
                        }
                    }
                    else{
                        val = $(this).val() ;
                    }
                   
                    formData[$(this).attr('name')] = val;
                    $(this).next('.form-info').html('');

                    // validation
                    if($(this).prop('required') && val === ''){
                        $(this).next('.form-info').html('<small class="d-block text-danger">Ce champ est obligatoire</small>');
                        valid = false ;
                    }
                    if($(this).attr('type') === 'email' && !ValidateEmail(val)){
                        $(this).next('.form-info').html('<small class="d-block text-danger">L\'email est invalide</small>');
                        valid = false ;
                    }

                });
                value = formData ;
                parent = 0 ;

                users[current_user]['info'] = value ;
                // console.log(formData);
            }

            if(type === 'accompagnant_start'){
              current_user = 1 ;
            }

            var data = {
                'action': 'ajax_get_booking_next_step',
                'type' : type,
                'value' : value,
                'parent' : value,
                'level' : level,
                'current_user' : current_user,
                'users' : users,
                'name' : name,
            };

            if(valid) {
                $.ajax({
                    url: agencea.ajaxurl,
                    data: data,
                // processData: false,
                    //contentType: false,
                    type: 'POST',
                    success: function(response) {

                        if(response.level){
                            toggleActiveLevel(response.step, response.level);
                        }

                        if(response.step){
                            toggleActiveStep(response.step, current_user);
                        }
                        current_step = response.step ;

                        $('#step'+response.step+'--content').append(response.col2.html);

                        $('#col3').html(response.col3.html);
                        hideLoader();

                        let _type = (type === 'summary') ? 'info' : type ;
                        saveChoices(current_user, _type, response.name, value);
                        $('#booking').attr('data-type', type);

                        $('[data-change]').trigger('change');

                        var scrollTarget = response.level > 1 && $('div[data-level="'+response.level+'"]:visible').length > 0 ?  $('div[data-level="'+response.level+'"]:visible') : $('#current-step--title') ;
                        // console.log('scroll1');

                        document.documentElement.scrollTo({
                            top: scrollTarget.offset().top - 170,
                            behavior: "smooth"
                        });

                        if(type === 'summary'){
                            $('#current-step--title').text('Récapitulatif de votre demande :');
                        }
                        // console.log(type) ;
                        // console.log('lol') ;

                        // if(type !== 'summary'){
                        //     choicesSummary(current_user, type, response.name, value);
                        // }
                    }
                    
                });
            }
            else{ // invalid
                hideLoader();
            }

            //return false ;
        });


        // Submit booking data
        $(document).on('click', '#submit-booking', function() {
            showLoader();

            var data = {
                'action': 'ajax_save_booking',
                'current_user' : current_user,
                'users' : users
            };


            $.ajax({
                    url: agencea.ajaxurl,
                    data: data,
                    type: 'POST',
                    success: function(response) {
                        if(response.status === 'success'){
                            localStorage.removeItem('users');
                            window.dataLayer.push({
                                "event":"cure-form-success"
                            });
                        }
                        else{
                        //   console.log(response);
                        }
                        let html = response.message;

                        $('#col2').html(`<div class="card"><div class="card-body">${html}</div></div>`);
                        hideLoader();

                        // console.log('scroll2');

                        document.documentElement.scrollTo({
                            top: $('#current-step--title').offset().top,
                            behavior: "smooth"
                        });
                        
                    
                    }
                    
                });


            return false ;
        });

        // Checkbox choix des options
        $(document).on('change', '.form-check-input[data-type="options_selection"]', function(){
            let _value = [];
            let button = $(this).parents('.type-level').find('.submit-choice');
           
            let max = button.attr('data-max') ;
            
            $('.form-check-input[data-type="options_selection"]').each(function () {
                if( $(this).prop('checked')){
                    _value.push($(this).attr('data-value') );
                }
            });

            //console.log(_value);
          
            button.attr('data-value', _value.join(','));
           
            if( (max > 0 && _value.length >= max) || (max == 0 && _value.length > 0)){
                $('.form-check-input[data-type="options_selection"]').each(function () {
                    if( max > 0 && !$(this).prop('checked')){
                        $(this).prop('disabled', true);
                    }
                    else{
                        $(this).prop('disabled', false);
                    }
                });
                button.prop('disabled',false);
            }
             else{
                button.prop('disabled',true);
                $('.form-check-input[data-type="options_selection"]').each(function () {
                    $(this).prop('disabled', false);
                });
             }
        });


        // Options hébergement
        $(document).on('change', '.form-check-input[data-type="hosting_options"]', function(){
            let _value = [];
            let _name = [];
            let button = $(this).parents('.type-level').find('.submit-choice');
           
            $('.form-check-input[data-type="hosting_options"]').each(function () {
                if( $(this).prop('checked')){
                    _value.push($(this).val() );
                    _name.push($(this).next('label').text() );
                }
            });

           // console.log(_value);
            //console.log(_name);
          
            button.attr('data-value', _value.join(','));
            button.attr('data-name', _name.join(','));
        
        });

      
        // Navigation entre les steps
        $(document).on('click', '.step-navigation', function(){
            if(!$(this).hasClass('disabled')){
                let step = $(this).parents('li').data('step');
                toggleActiveStep(step, current_user);
            }
            return false ;
        });
    }

    

});





